import React from 'react'
import { Substatus, SubstatusName } from './status'
import { Query } from 'react-apollo'
import gql from 'graphql-tag'

export const substatusAliasQuery = gql`
  query SubstatusAlias($organizationUuid: ID!, $substatus: SubstatusArgs!) {
    substatusAlias(organizationUuid: $organizationUuid, substatus: $substatus) {
      organizationUuid
      substatus
      alias
    }
  }
`

const isNotEmpty = (data) => {
  if (Object.keys(data).length > 0) {
    return true
  }
  return false
}

export interface ChildProps {
  readonly substatusAlias?: Substatus
  readonly refetch: () => Promise<any>
}

interface Props {
  readonly organizationUuid: string
  readonly substatus: SubstatusName
  readonly children: (props: ChildProps) => React.ReactNode
}

export function SubstatusAliasQuery({
  organizationUuid,
  substatus,
  children
}: Props) {
  return (
    <Query<{
      readonly substatusAlias: {
        readonly alias: string
        readonly organizationUuid: string
        readonly substatus: SubstatusName
      }
    }>
      query={substatusAliasQuery}
      variables={{ organizationUuid, substatus }}
      errorPolicy="all"
    >
      {({ error, data, loading, refetch }) => {
        // data can return as undefined or {} when no alias is configured
        if (
          !error &&
          !loading &&
          !!data &&
          isNotEmpty(data) &&
          !!data.substatusAlias
        ) {
          const {
            substatusAlias: { substatus, alias }
          } = data

          return children({
            substatusAlias: new Substatus(substatus, alias, alias, true, alias),
            refetch
          })
        }

        return children({ substatusAlias: undefined, refetch })
      }}
    </Query>
  )
}
